import Image from 'next/image'
import YouTube, { type YouTubeProps, type YouTubeEvent } from 'react-youtube'
import styled from 'styled-components'

import { trackVideoEvent } from '@/lib/gtm/gtmV2'

import { MediaAndContentLayout } from './MediaAndContentLayout'

const StyledContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 472px;
  gap: 16px;

  span {
    text-transform: uppercase;
    display: flex;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};

    img {
      margin-left: 12px;
    }

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    }
  }

  h4 {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: 46px;
    line-height: 64px;
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: 34px;
      line-height: 48px;
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
      margin: 0;
    }
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    gap: 12px;
  }
`

const StyledVideoContainer = styled.div`
  width: 100%;
  height: auto;
`

const StyledVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 30px;
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`

export const GutShotVideoSection = () => {
  const sendEvent = (action: 'Play' | 'Pause' | 'Complete', { target }: YouTubeEvent<number>) => {
    const currentVideoTime = target.getCurrentTime()
    trackVideoEvent('gut_shot', action, target.videoTitle, currentVideoTime)
  }

  const onPlay: YouTubeProps['onPlay'] = (event) => sendEvent('Play', event)
  const onPause: YouTubeProps['onPause'] = (event) => sendEvent('Pause', event)
  const onComplete: YouTubeProps['onEnd'] = (event) => sendEvent('Complete', event)

  return (
    <MediaAndContentLayout
      media={
        <StyledVideoContainer>
          <StyledVideo>
            <YouTube videoId="PulKaUA5F18" onPlay={onPlay} onPause={onPause} onEnd={onComplete} />
          </StyledVideo>
        </StyledVideoContainer>
      }
      content={
        <StyledContent>
          <span>
            As seen in <Image src="/assets/img/logos/m-and-s.png" alt="M&S" width={61} height={26} />
          </span>
          <h4>Learn about the Gut Shot with Professor Tim Spector</h4>
          <p>
            Discover how we helped M&S to develop a delicious daily drink that supports your gut health. Created with
            our world-leading science.
          </p>
        </StyledContent>
      }
      orientation="right"
    />
  )
}
